import React, { useState } from 'react';
import './FAQSection.css';

const faqs = [
    {
        question: "¿Cuánto cuesta el salto tándem?",
        answer: "El salto tándem con instructor cuesta 7800 pesos por persona. Se requiere una seña de 1300 pesos 10 días antes.",
    },
    {
        question: "¿Cuáles son los requisitos para saltar?",
        answer: "No pesar más de 95 kg (hombres) o 85 kg (mujeres). No tener problemas cardíacos o estar embarazada.",
    },
    {
        question: "¿Cómo puedo pagar?",
        answer: "Se puede pagar por transferencia a BROU, Abitab o RedPagos.",
    },
    {
        question: "¿Qué pasa si hay mal clima?",
        answer: "El staff evalúa el clima el mismo día del salto. Si no es seguro, se reprograma sin costo.",
    },
];

function FAQSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faq" className="faq">
            <h2 className="faq__title">Preguntas Frecuentes</h2>
            <div className="faq__list" role="list">
                {faqs.map((faq, index) => (
                    <div key={index} className="faq__item" role="listitem">
                        <button
                            className="faq__question"
                            onClick={() => toggleFAQ(index)}
                            aria-expanded={openIndex === index}
                        >
                            {faq.question}
                            <span className={`faq__arrow ${openIndex === index ? "faq__arrow--open" : ""}`}>&#9662;</span>
                        </button>
                        {openIndex === index && (
                            <p className="faq__answer" role="region">
                                {faq.answer}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}

export default FAQSection;
